import { Box, Button, Stack } from "@mui/material";
import { T } from "../../../util/t";
import { ArrowBack } from "@mui/icons-material";
import { useFormState } from "react-hook-form";
import { SubmitButton } from "../SubmitButton";

export const GoBackButton = ({ control, fullWidth, goBack }) => {
    const { isSubmitting } = useFormState({ control });

    return goBack &&
        <Button fullWidth={fullWidth} onClick={goBack} startIcon={<ArrowBack/>} disabled={isSubmitting}>
            <T>Go back</T>
        </Button>;
};

export const WizardFormWrapper = ({ control, handleSubmit, buttonLabel, goBack, children }) =>
    <form onSubmit={handleSubmit}>
        <Box borderTop={1} borderBottom={1} borderColor="border.light" pt={3} mt={3} mb={3}>
            {children}
        </Box>

        <Stack spacing={2}>
            <SubmitButton control={control} buttonLabel={buttonLabel} fullWidth/>
            <GoBackButton control={control} goBack={goBack} fullWidth/>
        </Stack>
    </form>;
